module.exports = __webpack_public_path__ + "media/images/flags/mh-c47cb4a567a20dc96975f1ce18ab1b4b.svg";